import {DasUBoot} from "../DasUBoot";
import {DasUBootStatics} from "./DasUBootStatics";
import {DasUBootSound} from "../sound/DasUBootSound";
import {DasUBootSymbol} from "../reels/DasUBootSymbol";

/**
 * Created by jonas on 2021-06-04.
 */

export class ReelUtils {

    public static highlightWinLine(reel:number, firstWinHighlightReel:number = DasUBootStatics.firstWinHighlightReel) {
        for (let possibleLine of DasUBoot.model.possibleWinData.lines) {
            if (reel >= firstWinHighlightReel && possibleLine.reels[reel]) {
                const potentialWins = possibleLine.matrix.getAllCoordinateForValue(true);
                if (potentialWins.length > 0) {
                    let sound = DasUBootSound.POTENTIAL_WIN + (reel + 1);
                    DasUBoot.soundPlayer.playSound(sound);
                }
                for (let potWin of potentialWins) {
                    if (potWin.column > reel) {
                        break;
                    }
                    const symbolData = DasUBoot.reelView.getVisibleSymbolAt(potWin.column, potWin.row);
                    const symbol = <DasUBootSymbol>symbolData.positionable;
                    symbol.playPotentialWinAttention();
                }
            }
        }
    }
}